
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";
import TicketAccessControl from "@/components/settings/access-control/TicketAccessControl";
import BusinessHoursSettings from "@/components/settings/BusinessHoursSettings";
import GithubReposSettings from "@/components/settings/GithubReposSettings";
import McpSettings from "@/components/settings/McpSettings";
import NotificationSettings from "@/components/settings/NotificationSettings";
import PendingApprovals from "@/components/settings/PendingApprovals";
import TagsSettings from "@/components/settings/TagsSettings";
import WebhooksSettings from "@/components/settings/WebhooksSettings";
import ChannelSettings from "@/components/settings/channels/ChannelSettings";
import WhatsAppSettings from "@/pages/WhatsAppSettings";
import { Bell, Clock, Github, KeyRound, MessageCircle, MessagesSquare, Sparkles, Tag, UserCheck, Webhook } from "lucide-react";
import { useSearchParams } from "react-router-dom";

const SECTIONS = [
  { value: "access-control", label: "Controle de Acesso", icon: KeyRound },
  { value: "pending-approvals", label: "Aprovações Pendentes", icon: UserCheck },
  { value: "tags", label: "Tags", icon: Tag },
  { value: "channel-settings", label: "Slack", icon: MessageCircle },
  { value: "whatsapp", label: "WhatsApp", icon: MessagesSquare },
  { value: "business-hours", label: "Horário de Atendimento", icon: Clock },
  { value: "notifications", label: "Notificações", icon: Bell },
  { value: "mcp", label: "Claude (MCP)", icon: Sparkles },
  { value: "webhooks", label: "Webhooks", icon: Webhook },
  { value: "github", label: "GitHub", icon: Github },
];

const SECTION_VALUES = SECTIONS.map((s) => s.value);

export default function SettingsTabs() {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawSection = searchParams.get("section");
  const section = SECTION_VALUES.includes(rawSection || "") ? rawSection! : "access-control";

  function handleSectionChange(value: string) {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set("section", value);
        return next;
      },
      { replace: true }
    );
  }

  return (
    <Tabs
      value={section}
      onValueChange={handleSectionChange}
      orientation="vertical"
      className="flex flex-col gap-6 md:flex-row"
    >
      <TabsList className="h-auto w-full shrink-0 flex-row flex-wrap justify-start gap-1 bg-transparent p-0 md:w-56 md:flex-col">
        {SECTIONS.map((section) => (
          <TabsTrigger
            key={section.value}
            value={section.value}
            className={cn(
              "w-full justify-start gap-2 px-3 py-2",
              "data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-none"
            )}
          >
            <section.icon className="h-4 w-4" />
            {section.label}
          </TabsTrigger>
        ))}
      </TabsList>

      <div className="min-w-0 flex-1">
        <TabsContent value="access-control" className="mt-0">
          <TicketAccessControl />
        </TabsContent>

        <TabsContent value="pending-approvals" className="mt-0">
          <PendingApprovals />
        </TabsContent>

        <TabsContent value="tags" className="mt-0">
          <TagsSettings />
        </TabsContent>

        <TabsContent value="channel-settings" className="mt-0">
          <ChannelSettings />
        </TabsContent>

        <TabsContent value="whatsapp" className="mt-0">
          <WhatsAppSettings />
        </TabsContent>

        <TabsContent value="business-hours" className="mt-0">
          <BusinessHoursSettings />
        </TabsContent>

        <TabsContent value="notifications" className="mt-0">
          <NotificationSettings />
        </TabsContent>

        <TabsContent value="mcp" className="mt-0">
          <McpSettings />
        </TabsContent>

        <TabsContent value="webhooks" className="mt-0">
          <WebhooksSettings />
        </TabsContent>

        <TabsContent value="github" className="mt-0">
          <GithubReposSettings />
        </TabsContent>
      </div>
    </Tabs>
  );
}
